import React from 'react'
import API from '../../services/API'
import S3DocumentUploadDisplay from '../../components/images/S3DocumentUploadDisplay'
import Alert from '@mui/material/Alert'
import Stack from '@mui/material/Stack'
import { FormSection } from './FormKit'

const NI_LETTER =
  'An official letter or document from a government agency (for example HM Revenue and Customs, Department for Work and Pensions, or the Social Security Agency in Northern Ireland) or previous employer, showing your name and National Insurance number'

const RightToWorkDocuments = ({
  hasUKPassport,
  hasBirthCertificate,
  certificateRegistration,
  citizenship,
  formValues,
  setFormValues,
}) => {
  const isBritish = citizenship === 'a British Citizen'
  const required = [
    ...(isBritish && hasUKPassport === true ? ['Your passport'] : []),
    ...(isBritish && hasBirthCertificate === true
      ? [
          'A birth or adoption certificate from the UK, the Channel Islands or the Isle of Man',
          NI_LETTER,
        ]
      : []),
    ...(isBritish && certificateRegistration === true
      ? [
          'A certificate of registration or naturalisation as a British citizen',
          NI_LETTER,
        ]
      : []),
  ]

  const saveDocuments = (documents) => {
    setFormValues((prev) => ({
      ...prev,
      rightToWork: { ...prev.rightToWork, documents },
    }))
    API.post('/update-employee-own-application', {
      _id: formValues._id,
      rightToWork: { ...formValues.rightToWork, documents },
    })
  }

  return (
    <FormSection title="Documents">
      {required.length > 0 && (
        <Alert severity="info" icon={false}>
          Please upload:
          <Stack component="ul" m={0} mt={0.5} pl={2.5} gap={0.5}>
            {required.map((doc) => (
              <li key={doc}>{doc}</li>
            ))}
          </Stack>
        </Alert>
      )}
      {citizenship === 'from somewhere else' && (
        <Alert severity="warning">
          Please speak with a member of the team to discuss documentation
          requirements.
        </Alert>
      )}
      <S3DocumentUploadDisplay
        existingDocuments={formValues?.rightToWork?.documents}
        s3folder="employees/application-righttowork-documents"
        actionAfterSubmit={(newDocKey) =>
          saveDocuments([
            ...(formValues?.rightToWork?.documents ?? []),
            newDocKey,
          ])
        }
        actionAfterDelete={(newDocsArray) => saveDocuments(newDocsArray)}
      />
    </FormSection>
  )
}

export default RightToWorkDocuments
